import React, { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { mtfindCpv } from "../api/mtfindCpv";
import { mtfindCpvId } from "../api/mtfindCpvId";
import { mtFindPerson } from "../api/mtFindPerson";
import { generarImagenReporte } from "../api/generarImagenReporte";
import { testDownloadFile } from "../api/testDownloadFile";
import { validateComprobanteLaboral } from "../api/validateComprobanteLaboral";
import { jsPDF } from "jspdf";
import Modal from 'react-bootstrap/Modal';
import logo from '../assets/dpr_lab_logo.png'
import bar1 from '../assets/bar1.png'
import check1 from '../assets/Check1.png'
import "./print.css";
import "./style.css";


const N4_Historial = () => {
    const componentRef = useRef(null);
    const isRunned = useRef(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [modalShow, setModalShow] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [imagenFront, setImagenFront] = useState("");
    const [imagenBack, setImagenBack] = useState("");

    /*---Nombre reporte---*/

    const date = new Date();

    const formattedDate = date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');

    const [cpv, setCpv] = useState(params.get("i"));

    /*---------------------------*/

    const [vigenciaCpv, setVigenciaCpv] = useState("");
    const [robos, setRobos] = useState("");
    const [accidentes, setAccidentes] = useState("");
    const [distancias, setDistancias] = useState("");
    const [conduccion, setConduccion] = useState("");
    const [experiencia, setExperiencia] = useState("");
    const [equipo, setEquipo] = useState("");

    const [numeroLic, setNumeroLic] = useState("");
    const [tipoLic, setTipoLic] = useState("");
    const [vigencia, setVigencia] = useState("");
    const [edoEmisorISO, setEdoEmisorISO] = useState("");
    const [edoEmisor, setEdoEmisor] = useState("");
    const [similarity, setSimilarity] = useState("");
    const [numImagenCompetencia, setNumImagenCompetencia] = useState("");
    const [imagenLogoDPRStr, setImagenLogoDPRStr] = useState("");
    const [carLogisticStr, setCarLogisticStr] = useState("");
    const [checkDeepBlueStr, setCheckDeepBlueStr] = useState("");

    const [experienciaRes, setExperienciaRes] = useState("");
    const [capacidadRes, setCapacidadRes] = useState("");
    const [competencia, setCompetencia] = useState("");
    const [conocimiento, setConocimiento] = useState("");
    const [alcohol, setAlcohol] = useState("");
    const [fatiga, setFatiga] = useState("");
    const [peatones, setPeatones] = useState("");
    const [interseccion, setInterseccion] = useState("");

    const [showTendencia, setShowTendencia] = useState(false);
    const [emiteTxt, setEmiteTxt] = useState("");
    const [listActividad, setListActividad] = useState([]);
    const [ingresoMensual, setIngresoMensual] = useState("");
    const [tendenciaBl, setTendenciaBl] = useState(false);
    const [listaAcademicolBl, setlistaAcademicolBl] = useState(false);
    const [nombreComprobante, setNombreComprobante] = useState("");

    const [cardSvgP, setCardSvgP] = useState("");
    const [logoDPR, setLogoDPR] = useState();
    const [check_deepBlue, setCheck_deepBlue] = useState("");
    const [cardSvgBlack, setCardSvgBlack] = useState("");
    const [qr, setQr] = useState("");

    const [validateNivelUno, setvalidateNivelUno] = useState(false);
    const [validateNivelDos, setvalidateNivelDos] = useState(false);
    const [validateNivelTres, setvalidateNivelTres] = useState(false);
    const [emisorPrimaria, setemisorPrimaria] = useState('');
    const [emisorSecundaria, setemisorSecundaria] = useState('');
    const [emisorBachillerato, setemisorBachillerato] = useState('');

    const [strNivelMaximo, setStrNivelMaximo] = useState('');
    const [textoCv, setTextoCv] = useState('');

    const [gradoPrimaria, setgradoPrimaria] = useState('');
    const [tituloPrimaria, settituloPrimaria] = useState('');
    const [periodoPrimaria, setperiodoPrimaria] = useState('');

    const [gradoSecundaria, setgradoSecundaria] = useState('');
    const [tituloSecundaria, settituloSecundaria] = useState('');
    const [periodoSecundaria, setperiodoSecundaria] = useState('');

    const [gradoBachillerato, setgradoBachillerato] = useState('');
    const [tituloBachillerato, settituloBachillerato] = useState('');
    const [periodoBachillerato, setperiodoBachillerato] = useState('');
    const [numCedula, setnumCedula] = useState('');

    /*Nuevos states para Historial Academico*/
    const [numeroEstudios, setnumeroEstudios] = useState(3)
    const [numeroCedula, setnumeroCedula] = useState([]);
    const [nombreEstudio, setnombreEstudio] = useState([]);
    const [institucion, setInstitucion] = useState([]);
    const [pais, setPais] = useState([])
    const [estatus, setEstatus] = useState([]);

    const valorCicloAreas = 10;

    const handleClose = () => {
        setShow(false);
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            localStorage.clear();

            if (params.get("i") == null) {

                setLoading(false);
                setModalShow(false);
                setShow(true);
                setShowStatus(500);
                setShowMessage("Error al obtener el cpv")

            } else {

                setLoading(true);
                setTendenciaBl(false);

                const dataImgRepo = await generarImagenReporte();

                const cardSvgPStr =
                    "data:image/png;base64," + dataImgRepo.cardSvgP + "";

                const logoDPRStr =
                    "data:image/png;base64," + dataImgRepo.logoDPR + "";

                const check_deepBlueStr =
                    "data:image/png;base64," + dataImgRepo.check_deepBlue + "";

                const cardSvgBlackStr =
                    "data:image/png;base64," + dataImgRepo.cardSvgBlack + "";

                const qrStr =
                    "data:image/png;base64," + dataImgRepo.qr + "";

                setLogoDPR(logoDPRStr);
                setCardSvgP(cardSvgPStr);
                setCheck_deepBlue(check_deepBlueStr);
                setCardSvgBlack(cardSvgBlackStr);
                setQr(qrStr);

                const objCpv = {
                    cpv: params.get("i"),
                };

                const response = await mtfindCpvId(objCpv);

                if (response.status === 200) {

                    if (response.listLaboral !== null) {
                        setListActividad(response.listLaboral);
                        setlistaAcademicolBl(false);
                    } else {
                        setlistaAcademicolBl(true);
                    }

                    setCompetencia(response.aniosExperiencia);
                    setIngresoMensual(response.ingresoMensual);

                    // validacion de las tendencia de las images 

                    const objAWS = {
                        nombreUser: response.nombre,
                        paterno: response.paterno,
                        materno: response.materno,
                        nombreComprobante0: "Pri_" + params.get("i") + "_1.png",
                        nombreComprobante1: "Se_" + params.get("i") + "_1.png",
                        nombreComprobante2: "Bach_" + params.get("i") + "_1.png"
                    };

                    const responseComprobanteLaboral = await validateComprobanteLaboral(objAWS);

                    if (responseComprobanteLaboral.status !== 200) {
                        setTendenciaBl(true);
                    } else {
                        setTendenciaBl(false);
                    }

                    const imagenLogoDPR =
                        "data:image/png;base64," + response.logoDPR + "";
                    setImagenLogoDPRStr(imagenLogoDPR);

                    const imagenCarLogistic =
                        "data:image/png;base64," + response.carLogistic + "";
                    setCarLogisticStr(imagenCarLogistic);

                    const imagenCheckDeepBlue =
                        "data:image/png;base64," + response.checkDeepBlue + "";
                    setCheckDeepBlueStr(imagenCheckDeepBlue);

                    // Imagenes para generar el reporte 

                    const imagenCompetencia =
                        "data:image/png;base64," + response.numImagenCompetencia + "";
                    setNumImagenCompetencia(imagenCompetencia);

                    setNombreComprobante(response.comprobante);
                    setCpv(response.cpv);
                    setVigenciaCpv(response.vigenciaCpv);
                    setRobos(response.robos);
                    setAccidentes(response.accidentes);
                    setConduccion(response.conduccion);
                    setDistancias(response.distancias);
                    setExperiencia(response.experiencia);
                    setEquipo(response.equipo);
                    setNumeroLic(response.numeroLic);
                    setTipoLic(response.tipoLic);
                    setVigencia(response.vigencia);
                    setEdoEmisorISO(response.edoEmisorISO);
                    setEdoEmisor(response.edoEmisor);
                    setSimilarity(response.similarity);
                    setExperienciaRes(response.experienciaRes);
                    setCapacidadRes(response.capacidad);
                    setConocimiento(response.conocimiento);
                    setAlcohol(response.alcohol);
                    setFatiga(response.fatiga);
                    setPeatones(response.peatones);
                    setInterseccion(response.interseccion);
                    setEmiteTxt(response.emiteTxt);

                    /***************************************************************************************************************** */

                    const objPerson = {
                        cpv: params.get("i"),
                    };

                    const responseIdPersonIdCpv = await mtfindCpv(objPerson);

                    if (responseIdPersonIdCpv.status == 200) {

                        const objCons = {
                            id: responseIdPersonIdCpv.id
                        }

                        const responsePersonFind = await mtFindPerson(objCons);

                        const objAWSImage = {
                            img: "" + responsePersonFind.imagenUltimoGrado + "" + params.get("i") + "_1.png"
                        };

                        const dataImgAWS = await testDownloadFile(objAWSImage);

                        const imagenStrFrontID =
                            "data:image/png;base64," + dataImgAWS.img + "";
                        setImagenFront(imagenStrFrontID);

                        if (responsePersonFind.docPrimaria === true) {
                            setgradoPrimaria(responsePersonFind.gradoPrimaria)
                            settituloPrimaria(responsePersonFind.tituloPrimaria);
                            setemisorPrimaria(responsePersonFind.emisorPrimaria);
                            setperiodoPrimaria(responsePersonFind.periodoPrimaria);
                            setvalidateNivelUno(true);
                        }

                        if (responsePersonFind.docSecundaria === true) {


                            setgradoSecundaria(responsePersonFind.gradoSecundaria)
                            settituloSecundaria(responsePersonFind.tituloSecundaria);
                            setemisorSecundaria(responsePersonFind.emisorSecundaria);
                            setperiodoSecundaria(responsePersonFind.periodoSecundaria);
                            setvalidateNivelDos(true);
                        }

                        if (responsePersonFind.docBachillerato === true) {

                            setgradoBachillerato(responsePersonFind.gradoBachillerato)
                            settituloBachillerato(responsePersonFind.tituloBachillerato);
                            setemisorBachillerato(responsePersonFind.emisorBachillerato);
                            setperiodoBachillerato(responsePersonFind.periodoBachillerato);
                            setvalidateNivelTres(true);
                        }

                        if (responsePersonFind.curriculumVitae == true) {

                            setTextoCv('adjunto');

                        } else {

                            setTextoCv('No adjunto');

                        }

                        if (responsePersonFind.numCedula !== null) {
                            setnumCedula(responsePersonFind.numCedula);
                            setEstatus("Recabado/ DPR")
                        } else {
                            setEstatus("No Recabado/DPR")
                        }
                        
                        setStrNivelMaximo(responsePersonFind.strNivelMaximo);



                        /***************************************************************************************** */

                        if (response.numImageTendencia === 1) {
                            setShowTendencia(true);
                        } else {
                            setShowTendencia(false);
                        }

                        handlePrint();

                    }

                } else {

                    setLoading(false);
                    setShow(true);
                    setShowStatus(response.status);
                    setShowMessage(response.message);

                }

                setLoading(false);

            }
        }

        createSession();

    }, []);


    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        print: async () => {
            const doc = new jsPDF();
            doc.html(componentRef.current, {
                html2canvas: {
                    removeContainer: true,
                    scale: 0.19
                },
                margin: 5,
                x: -1,
                async callback(doc) {
                    await doc.save('Autenticación_Educativa_' + cpv + '_' + formattedDate);
                },
            });
        },

    });

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>


            <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
                <div
                    className=" animate__animated animate__fadeIn"
                    ref={componentRef}
                    style={{ display: "flex", width: "1070px", border: "none" }}
                >
                    <div className="relativeCSS">
                        <style type="text/css" media="print">
                            {
                                "@page {  size: A4;  }"
                            }
                        </style>
                        {/* hoja 1 */}
                        <br />
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <article className="newCard__style ">
                                        <div className="Bar__top p-2">
                                            <div className="container-fluid">
                                                <div className="row">
                                                    <div className="col-3">
                                                        <img src={logo} alt="" className="w-100" />
                                                    </div>
                                                    <div className="col-9 ">
                                                        <div className="subtitle d-flex justify-content-start  h-100">
                                                            <div className="mt-3">
                                                                <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                                                                <br />
                                                                <h5 className="Bar__top--sizing p-0">Autenticación Educativa</h5>
                                                            </div>
                                                            <section className="mt-2">
                                                                <div className="Bar__button rounded-pill">
                                                                    <span className="p-1"><strong>IDe</strong></span>
                                                                </div>
                                                            </section>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="conteiner-fluid info-Bar">
                                            <div className="row p-3 ">
                                                <div className="col-8">
                                                    <ul className="pNone text-start p-3">
                                                        <li>
                                                            <img src={check1} alt="" className="imgCheck" />
                                                            <span className="f20">Autenticación de Identidad</span>
                                                        </li>
                                                        <li>
                                                            <img src={check1} alt="" className="imgCheck" />
                                                            <span className="f20">Documentación Probatoria</span>
                                                        </li>
                                                    </ul>
                                                    <div className=" d-flex Info__aling align-items-end">
                                                        <div className="expires">
                                                            <span className="text-lg">Vence &nbsp;: <strong>{vigenciaCpv}</strong> </span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-4">
                                                    <section className=" d-flex flex-column w-100">
                                                        <img className="  " src={qr} alt="" />
                                                        <span className="cpv__text  text-center mt-1">CPV&nbsp;: <strong>{cpv}</strong> </span>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                    </article>
                                    <div className="text-one">
                                        <div className="textInfo f12">
                                            ATENCIÓN &nbsp;:&nbsp; Este certificado es válido únicamente si la fecha en el recuadro superior
                                            izquierdo de este Reporte se encuentra vigente. Para comprobar su autenticidad
                                            escanee el código QR y/o ingrese el código CPV en www.midpr.net.
                                        </div>
                                    </div>
                                    <div className="textNotifique pt-0">
                                        *Notifique si este Reporte ha sido alterado al +52 5571605526 y/o en
                                        www.midpr.net
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="subTitleCardTwo f12 subTitleCardTwo__sizing">
                                        Este &nbsp; Reporte da constancia de la recopilación y corroboración de información aportada por el Aplicante a través de medios digitales, de manera completa y concluyente, obteniendo la información presentada a continuación:
                                    </div>
                                    <br />
                                    <div className="containerCardTwo">
                                        <div className="titleCard titleCard--sizing">RESULTADO &nbsp; OBTENIDO</div>

                                        <div className="centerButton">
                                            <div className="result">
                                                <div className="graph-half-circle mt-1">

                                                    <span className="Bar--text-level pt-1">
                                                        {strNivelMaximo}
                                                    </span>


                                                    <div className="d-flex justify-content-center  align-items-center w-100 pt-1 mt-0 ">
                                                        <button type="button" className=" rounded-pill BtnN4 p"><strong className="f20">Nivel &nbsp; Educativo</strong></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="textNotifique pt-0">
                                        *La interpretación de este Resultado Obtenido es
                                        responsabilidad exclusiva del lector.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">

                                    <div className="card">

                                        <div className="titleCard pt-1">
                                            DOCUMENTACIÓN &nbsp; PROBATORIA
                                        </div>

                                        <div className="f12 Documentacion--sizing">
                                            <b>Estatus:</b> {estatus} <br />
                                            <b>Número:</b> {numCedula} <br />

                                        </div>
                                    </div>
                                    <br />

                                    <div className="buttonCenter">

                                        {!tendenciaBl ? (
                                            <>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="btn green trend rounded-pill">
                                                        TENDENCIA &nbsp; A CONSISTENTE
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="d-flex justify-content-center  align-items-center">
                                                    <button type="button" className="btn yellow trend rounded-pill">
                                                        TENDENCIA &nbsp; A INCONSISTENTE
                                                    </button>
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div className="f12--sizing text-center pt-1">
                                        *Consulte definiciones de estas métricas en www.midpr.net.
                                    </div>

                                </div>

                                <div className="col-6">

                                    <div className="card evaluated-areas tipo-d borderCard pt-1">
                                        <div className="titleCard">
                                            HISTORIAL &nbsp; ACADÉMICO
                                        </div>

                                        {validateNivelUno ? (
                                            <>
                                                <div className="infoData f12 Documentacion--sizing">
                                                    <b>Grado</b>: {gradoPrimaria}<br />
                                                    <b>Institución Educativa</b>: {tituloPrimaria}  <br />
                                                    <b>Número de Folio del Certificado</b>: {emisorPrimaria}  <br />
                                                    <b>Periodo</b>:  {periodoPrimaria}  <br />
                                                </div>
                                            </>
                                        ) : (
                                            <></>
                                        )}
                                        {validateNivelDos ? (
                                            <>
                                                <div className="infoData f12 Documentacion--sizing">
                                                    <b>Grado</b>: {gradoSecundaria}<br />
                                                    <b>Institución Educativa</b>: {tituloSecundaria}  <br />
                                                    <b>Número de Folio del Certificado</b>: {emisorSecundaria}  <br />
                                                    <b>Periodo</b>:  {periodoSecundaria}  <br />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="infoData f12 Documentacion--sizing">
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                </div>
                                            </>
                                        )}
                                        {validateNivelTres ? (
                                            <>
                                                <div className="infoData f12 Documentacion--sizing">
                                                    <b>Grado</b>: {gradoBachillerato}<br />
                                                    <b>Institución Educativa</b>: {tituloBachillerato}  <br />
                                                    <b>Número de Folio del Certificado</b>: {emisorBachillerato}  <br />
                                                    <b>Periodo</b>:  {periodoBachillerato}  <br />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="infoData f12 Documentacion--sizing">
                                                    <br />
                                                    <br />
                                                    <br />
                                                    <br />
                                                </div>
                                            </>
                                        )}

                                    </div>

                                    <div className="textNotifique pt-1">
                                        *Consulte al reverso de este Reporte las imágenes recabadas
                                    </div>

                                </div>

                            </div>
                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <br />
                                    <div className="subTitleCardTwo f12">
                                        Este proceso de certificacíon fue realizado de manera automatica a través de un
                                        dispositivo digital propiedad del Aplicante. Durante el proceso, se registraron
                                        una serie de datos de carácter personal que fueron analizados, validados y/o
                                        verificados que permitieron, posterior al análisis de la información, la obtención
                                        del dictamen presentado con respecto a la consistrencia o inconsistencia de estos
                                        de manera integral.
                                    </div>
                                </div>

                                <div className="col-6">
                                    <br />
                                    <div className="card evaluated-areas tipo-d borderCard pt-1">
                                        <div className="titleCard">
                                            CURRICULUM  &nbsp; VITAE
                                        </div>

                                        <div className="subTitleCardTwo f12">
                                            El Aplicante adjunta en formato libre un resumen de su formación académica,
                                            competencias profesionales, experiencia laboral, habilidades e idiomas.
                                        </div>
                                        <span className="text-center pt-1 pb-0"><b>Curriculum Vitae : </b> {textoCv}</span>

                                    </div>
                                </div>

                            </div>
                            <div className="note-gray note-emit">
                                <p>
                                    {emiteTxt}
                                </p>
                            </div>
                            <div className="textNotifique pt-1">
                                *Consulte al reverso nuestra Política de Privacidad y/o en www.midpr.net
                            </div>


                            <div className="card legal-advise borderCard">
                                <div className="titleCard  TitleAviso pb-1">AVISO &nbsp; LEGAL</div>
                                <div className="subTitleCardTwo f12 ">
                                    <p >
                                        La Calificación realizada de manera
                                        remota por el Aplicante, a la que hace
                                        referencia este Reporte, fue realizada
                                        a solicitud directa del Destinatario.
                                        Antes y durante la Calificación &nbsp;, fue
                                        autenticada la identidad del Aplicante{" "}
                                        y se registraron una serie de datos e información de
                                        carácter personal con su autorización expresa &nbsp;, lo cual
                                        permitió emitir una Evaluación Remota Confiable (&nbsp; ERC &nbsp;).
                                        El Destinatario acepta que todos los
                                        datos contenidos en el presente Reporte{" "}
                                        son confidenciales y de interés exclusivo y privado, que
                                        es compartida únicamente con el propósito que ha sido
                                        previamente informado por el{" "}
                                        Destinatario y que ha autorizado por el{" "}
                                        Aplicante previo a la aplicación de la{" "}
                                        Calificación &nbsp;. El{" "}
                                        Aplicante y/o el{" "}
                                        Destinatario de este Reporte aceptan de
                                        conformidad la responsabilidad sobre cualquier uso
                                        indebido o ilegal de este documento y su contenido, así
                                        como todos los términos y condiciones descritos al
                                        reverso.{" "}

                                        Una vez entregado este Reporte al Destinatario, el
                                        Fabricante se deslinda de toda responsabilidad sobre
                                        su interpretación, divulgación y uso

                                        .
                                    </p>
                                </div>
                            </div>
                            <div className="textNotifique f12">
                                Business &nbsp; Prey SA de CV hace referencia que con número de
                                registro DGSP&nbsp;/369-19/3919, está autorizada por la SSPC&nbsp;/DGSP
                                para la aplicación de Pruebas y Evaluación &nbsp; de Control de
                                Confianza de conformidad con los Lineamientos y Criterios
                                Técnicos &nbsp; publicados en el Diario Oficial de la Federación
                                (DOF) el 28 de abril de 2020.
                            </div>
                            <div style={{ paddingTop: "", background: "#FFF" }}>
                            </div>
                        </div>
                        <br />
                        <br />

                        {/* hoja 2 */}

                        <br />
                        <br />
                        <br />

                        {numeroEstudios === 3 ?
                            (
                                <>
                                    <br />
                                </>) :
                            (
                                <>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />

                                </>
                            )
                        }

                        <div className="div-vertical mt-15">
                            <div className="div-horizontal" id="div1">
                                <div className="card evaluated-areas tipo-d borderCard">
                                    <div className="titleCard">IMÁGENES &nbsp; RECABADAS</div>
                                    <div className="centerButton">
                                        <div id="container" style={{ whiteSpace: "nowrap" }}>
                                            <div id="image" style={{ display: "inline" }}>
                                                <img
                                                    src={imagenFront}
                                                    style={{ width: "50%", height: "50%" }}
                                                    className="ImagenMoto"
                                                />
                                            </div>
                                            &nbsp;
                                            <div id="image" style={{ display: "inline" }}>
                                                <img
                                                    src={imagenBack}
                                                    style={{ width: "50%", height: "auto" }}
                                                    className="ImagenMoto"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <div className="card evaluated-areas tipo-d borderCard">
                                    <div className="titleCard">OBSERVACIONES</div>

                                </div>
                                <br />

                                <br />
                                <div className="cardLeft">

                                    <div className="subTitleCardTwo f12">
                                        <b>Privacidad de Datos Personales &nbsp;</b> Para efectos del
                                        cumplimiento del artículo 9 de la Ley Federal de
                                        Protección de Datos Personales en Posesión de los
                                        Particulares (LFPDPPP &nbsp;), el Aplicante de la ERC manifiesta
                                        expresamente que otorgó su consentimiento para el
                                        tratamiento de sus datos personales sensibles, durante los
                                        procedimientos de recopilación y procesamiento, aceptando
                                        los términos y condiciones para tales efectos.
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Uso de las &nbsp; Marcas &nbsp;</b> DPR &nbsp;y las marcas asociadas son marcas
                                        registradas, protegida por los artículos 88 y 142 de la
                                        Ley de Propiedad Industrial (LPI &nbsp;), así como el convenio de
                                        París para efectos internacionales. El consumo o
                                        adquisición de cualquiera de los servicios vinculados a
                                        DPR &nbsp; y/o proporcionados por el Fabricante, no confieren al
                                        Aplicante y/o al Destinatario el derecho de uso de las
                                        marcas de DPR en ningún contexto y/o formato, ya que al
                                        hacerlo podría resultar en actividad fraudulenta y ser
                                        clasificado como un delito. La marca, propiedad
                                        intelectual o cualquier otro tipo de secreto industrial
                                        contenido en este Reporte, no autoriza el uso, explotación
                                        comercial, venta, reproducción o distribución de dicha
                                        información.
                                    </div>

                                    <div className="subTitleCardTwo f12">
                                        <b>Uso de Información por Terceros &nbsp;</b> Al realizar la ERC&nbsp; , el
                                        Aplicante autoriza la entrega del resultado obtenido al
                                        Destinatario para el uso particular que ambos hayan
                                        acordado. Para el caso exclusivo de Elementos de Seguridad
                                        Privada, la entrega de este Reporte a la DGSP, se hará
                                        conforme a lo previsto en el artículo 9 de los citados
                                        Lineamientos y Criterios Técnicos.
                                    </div>
                                </div>
                                <div>
                                    <div className="card evaluated-areas tipo-d borderCard">
                                        <div className="titleContainerSinBorder f12">
                                            TEMAS DE INTERÉS
                                        </div>
                                        <div className="subTitleCardTwo f12">
                                            <ul className="espacio-ul-left">
                                                <li>
                                                    <strong>Nivel educativo:</strong> Máximo grado educativo (recabado).
                                                </li>
                                                <li>
                                                    <strong>Historial académico:</strong> Grado obtenido (recabado), escuela (recabada),
                                                    periodo (recabado), lugar (recabado), página (validado),
                                                    comprobante (recabado).
                                                </li>
                                                <li>
                                                    <strong>Licencia profesional:</strong> Número (recabado), nombre (recabado),
                                                    emisor (recabado), fecha (recabado), imagen (recabada).
                                                </li>
                                                <li>
                                                    <strong>Currículum vitae (recabado):</strong>  Formación académica, competencias
                                                    profesionales, experiencias laborales, habilidades e idiomas hablados.
                                                </li>

                                            </ul>
                                        </div>
                                    </div>
                                    <br />
                                    <br />
                                    <br />
                                    <br />
                                    <br />

                                    <div className="note-gray ">
                                        <p>
                                            <strong>Business &nbsp; Prey SA de CV</strong> con domicilio en
                                            Alfonso Reyes 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                                            DPR. Para mayor información llame al +52 5571605526 o
                                            visite el sitio <strong>www.midpr.net</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default N4_Historial